// Mock data for international travel website

export const heroImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1567502401034-b947ee46e249",
    alt: "Family at Arc de Triomphe Paris"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1475503572774-15a45e5d60b9",
    alt: "Family on beach"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1518658761661-a3c568ee7b64",
    alt: "Family jumping on beach"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1767411971751-cba9fcaaf298",
    alt: "Family with palm trees"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1769674110189-4a979d15ff03",
    alt: "Family beach sunset"
  }
];

export const destinations = [
  {
    id: 1,
    name: "Dubai",
    country: "UAE",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c",
    description: "Discover why Dubai needs to be visited",
    highlights: [
      "Iconic Burj Khalifa",
      "Luxury Shopping Malls",
      "Desert Safari Adventures",
      "World-class Theme Parks"
    ],
    promoted: true
  },
  {
    id: 2,
    name: "Vietnam",
    country: "Vietnam",
    image: "https://images.unsplash.com/photo-1643030595382-79273ae819d9",
    description: "Discover why Vietnam needs to be visited",
    highlights: [
      "Stunning Ha Long Bay",
      "Rich Cultural Heritage",
      "Delicious Street Food",
      "Beautiful Ancient Towns"
    ],
    promoted: true
  },
  {
    id: 3,
    name: "Bali, Indonesia",
    country: "Indonesia",
    image: "https://images.unsplash.com/photo-1518548419970-58e3b4079ab2",
    description: "Discover why Bali needs to be visited",
    highlights: [
      "Sacred Ancient Temples",
      "Pristine Beach Paradise",
      "Lush Rice Terraces",
      "Vibrant Local Culture"
    ],
    promoted: true
  },
  {
    id: 4,
    name: "Thailand",
    country: "Thailand",
    image: "https://images.unsplash.com/photo-1537956965359-7573183d1f57",
    description: "Discover why Thailand needs to be visited",
    highlights: [
      "Golden Buddhist Temples",
      "Exotic Beach Islands",
      "Authentic Thai Cuisine",
      "Family-friendly Resorts"
    ],
    promoted: false
  },
  {
    id: 5,
    name: "Singapore",
    country: "Singapore",
    image: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd",
    description: "Discover why Singapore needs to be visited",
    highlights: [
      "Futuristic Marina Bay",
      "Gardens by the Bay",
      "Universal Studios",
      "Safe & Clean City"
    ],
    promoted: false
  },
  {
    id: 6,
    name: "Malaysia",
    country: "Malaysia",
    image: "https://images.unsplash.com/photo-1596422846543-75c6fc197f07",
    description: "Discover why Malaysia needs to be visited",
    highlights: [
      "Iconic Petronas Towers",
      "Tropical Islands",
      "Diverse Culture",
      "Affordable Luxury"
    ],
    promoted: false
  }
];

export const lastMinuteDeals = [
  {
    id: 1,
    destination: "Dubai",
    title: "5 Days Dubai Extravaganza",
    image: "https://images.pexels.com/photos/15796414/pexels-photo-15796414.jpeg",
    price: "₹45,999",
    originalPrice: "₹65,999",
    discount: "30% OFF",
    travelDates: "15 Jan - 20 Jan 2025",
    limitedSeats: "Only 8 seats left",
    includes: "Flights + 4★ Hotel + Breakfast + City Tour"
  },
  {
    id: 2,
    destination: "Thailand",
    title: "7 Days Thailand Beach Paradise",
    image: "https://images.pexels.com/photos/732199/pexels-photo-732199.jpeg",
    price: "₹38,999",
    originalPrice: "₹52,999",
    discount: "25% OFF",
    travelDates: "18 Jan - 25 Jan 2025",
    limitedSeats: "Only 5 seats left",
    includes: "Flights + Beach Resort + All Meals + Island Hopping"
  },
  {
    id: 3,
    destination: "Bali",
    title: "6 Days Magical Bali Experience",
    image: "https://images.pexels.com/photos/9400976/pexels-photo-9400976.jpeg",
    price: "₹42,999",
    originalPrice: "₹58,999",
    discount: "27% OFF",
    travelDates: "22 Jan - 28 Jan 2025",
    limitedSeats: "Only 6 seats left",
    includes: "Flights + Villa Stay + Breakfast + Temple Tours"
  },
  {
    id: 4,
    destination: "Singapore",
    title: "5 Days Singapore Family Fun",
    image: "https://images.pexels.com/photos/33191052/pexels-photo-33191052.jpeg",
    price: "₹49,999",
    originalPrice: "₹68,999",
    discount: "28% OFF",
    travelDates: "25 Jan - 30 Jan 2025",
    limitedSeats: "Only 10 seats left",
    includes: "Flights + Hotel + Universal Studios + City Tour"
  }
];

export const earlyBirdDeals = [
  {
    id: 1,
    destination: "Vietnam",
    title: "7 Days Vietnam Heritage Tour",
    image: "https://images.unsplash.com/photo-1718942901264-2fd48f7da75f",
    price: "₹35,999",
    originalPrice: "₹48,999",
    discount: "Save ₹13,000",
    validTill: "31 Dec 2024",
    travelPeriod: "Feb - Apr 2025",
    includes: "Flights + Hotels + Ha Long Bay Cruise + City Tours"
  },
  {
    id: 2,
    destination: "Malaysia",
    title: "6 Days Malaysia Twin Cities",
    image: "https://images.pexels.com/photos/27786453/pexels-photo-27786453.jpeg",
    price: "₹32,999",
    originalPrice: "₹44,999",
    discount: "Save ₹12,000",
    validTill: "31 Dec 2024",
    travelPeriod: "Mar - May 2025",
    includes: "Flights + Hotels + Genting Highlands + City Tours"
  },
  {
    id: 3,
    destination: "Dubai",
    title: "5 Days Dubai Gold Package",
    image: "https://images.unsplash.com/flagged/photo-1559717865-a99cac1c95d8",
    price: "₹52,999",
    originalPrice: "₹72,999",
    discount: "Save ₹20,000",
    validTill: "31 Dec 2024",
    travelPeriod: "Jan - Mar 2025",
    includes: "Flights + 5★ Hotel + Desert Safari + Burj Khalifa"
  }
];

export const travelStories = [
  {
    id: 1,
    name: "Priya & Family",
    destination: "Thailand",
    image: "https://images.unsplash.com/photo-1475503572774-15a45e5d60b9",
    rating: 5,
    story: "Our 7-day Thailand trip was absolutely magical! The team planned everything perfectly - from flights to hotels to daily activities. Our kids loved the beach resorts and island hopping. The tour guides were knowledgeable and caring. We felt safe throughout the journey. Highly recommend for families!",
    date: "December 2024",
    package: "7 Days Thailand Family Package"
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    destination: "Dubai",
    image: "https://images.pexels.com/photos/28096282/pexels-photo-28096282.jpeg",
    rating: 5,
    story: "Dubai exceeded all expectations! The desert safari was thrilling, Burj Khalifa visit was unforgettable, and the shopping experience was world-class. Everything was pre-arranged, so we just had to enjoy. The customer service was exceptional from start to finish. Worth every penny!",
    date: "November 2024",
    package: "5 Days Dubai Extravaganza"
  },
  {
    id: 3,
    name: "Anjali & Rohit",
    destination: "Bali",
    image: "https://images.unsplash.com/photo-1767411971751-cba9fcaaf298",
    rating: 5,
    story: "Our Bali honeymoon was a dream come true! Beautiful temples, stunning beaches, amazing food, and luxurious villa stay. The itinerary was well-paced with perfect mix of adventure and relaxation. The team was available 24/7 for any assistance. Couldn't have asked for a better experience!",
    date: "October 2024",
    package: "6 Days Bali Romance Package"
  },
  {
    id: 4,
    name: "Sharma Family",
    destination: "Singapore",
    image: "https://images.pexels.com/photos/2833394/pexels-photo-2833394.jpeg",
    rating: 5,
    story: "Singapore with kids was fantastic! Universal Studios, Gardens by the Bay, and Night Safari were highlights. The hotel was centrally located, and transportation was seamless. Everything was organized to the minute. Our children are still talking about this trip. Perfect family destination!",
    date: "September 2024",
    package: "5 Days Singapore Family Fun"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "10 Hidden Gems in Vietnam You Must Visit",
    excerpt: "Discover lesser-known wonders beyond Ha Long Bay...",
    image: "https://images.unsplash.com/photo-1643030595382-79273ae819d9",
    category: "Travel Facts",
    readTime: "5 min read"
  },
  {
    id: 2,
    title: "Why Dubai is Perfect for Family Vacations",
    excerpt: "Safe, clean, and packed with family-friendly attractions...",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c",
    category: "Family Travel",
    readTime: "4 min read"
  },
  {
    id: 3,
    title: "Bali's Sacred Temples: A Spiritual Journey",
    excerpt: "Experience the rich cultural heritage and ancient traditions...",
    image: "https://images.unsplash.com/photo-1518548419970-58e3b4079ab2",
    category: "Heritage & Pilgrimage",
    readTime: "6 min read"
  },
  {
    id: 4,
    title: "Thailand Beach Guide: Which Island is Right for You?",
    excerpt: "From Phuket to Koh Samui, find your perfect beach paradise...",
    image: "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a",
    category: "Travel Facts",
    readTime: "7 min read"
  }
];

export const whatsappNumber = "+919876543210";
